import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/dailyReport/importer/dailyReportImporterActions';

export default importerReducers(actions);
